import { Chip, Stack } from '@locus-taxy/disco-ui';

interface EntityStatusChipsProps {
  status?: string;
  subStatus?: string;
}

export default function EntityStatusChips({
  status,
  subStatus,
}: Readonly<EntityStatusChipsProps>) {
  if (!status && !subStatus) {
    return null;
  }

  if (status && subStatus) {
    return (
      <Stack
        direction="row"
        gap={0}
        align="center"
        className="overflow-hidden rounded-full"
      >
        <Chip
          label={status}
          variant="filled"
          size="sm"
          className="rounded-r-none"
        />
        <Chip
          label={subStatus}
          variant="filled"
          size="sm"
          className="rounded-l-none"
        />
      </Stack>
    );
  }

  return <Chip label={status ?? subStatus} variant="filled" size="sm" />;
}
